.treatmentPlanTab {
    margin-top: 20px;
}

.headerContainer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.treatmentPlanStatus, .treatmentPlanDescription {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    white-space: pre-wrap;
}
